/* PW v95.8 (17 Oct): variant photo switching. Add-on to assets/pw-product.js, loaded after it from snippets/pw-pdp-tail.
   1. On load (no ?variant= in the URL) the gallery opens on the selected variant's photo.
   2. Tapping a color pill that is already selected still jumps to its photo.
   3. Option selects (if a preview script adds one) switch the photo too.
   v95.9 add-ons (17 Oct pm), only when variants have different prices:
   4. Top price reads "From $X" (cheapest variant) until the shopper taps an option.
   5. A live price line sits right under the option buttons ("Velveteen 50x60 · $53.99")
      and the Add to cart button carries the price, so phone shoppers never scroll up.
   6. Pet portrait pages: the dark "How it works" strip under the form is hidden (the gallery card covers it).
   v96.6 (18 Oct):
   7. Color pick jumps the gallery instantly (no smooth scroll). pw-product.js starts a smooth scrollTo on the
      scroll-snap track; on some phones that animation is dropped or cut short, so the counter and thumbs moved
      but the photo did not. We now check the real scroll position and snap straight to the photo.
   8. If the exact color + size combo has no photo, any variant of the same color that has one is used.
   9. Keyboard arrow changes on the pills switch the photo too.
   10. "From $Infinity" fix: when no variant reads available (draft or unpublished preview), "From" uses the
       cheapest variant overall. */
(function () {
  'use strict';
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function bind(root) {
    if (!root || root.dataset.pwVp) return;
    root.dataset.pwVp = '1';
    var el = root.querySelector('[data-pw-variants]'), vs = [];
    try { vs = JSON.parse(el.textContent) || []; } catch (e) { vs = []; }
    if (!vs.length) return;
    var colorIdx = -1;
    root.querySelectorAll('.pw-opt[data-pw-option-index]').forEach(function (g) {
      var n = g.querySelector('.pw-opt__name');
      var t = n ? n.textContent.trim().toLowerCase() : '';
      if (colorIdx < 0 && (t === 'color' || t === 'colour' || t.indexOf('color') > -1 || t.indexOf('colour') > -1)) colorIdx = parseInt(g.dataset.pwOptionIndex, 10);
    });
    function opts() {
      var o = [];
      root.querySelectorAll('.pw-opt[data-pw-option-index]').forEach(function (g) {
        var i = parseInt(g.dataset.pwOptionIndex, 10);
        var c = g.querySelector('input[data-pw-option-value]:checked') || g.querySelector('select');
        o[i] = c && c.value ? c.value : null;
      });
      return o;
    }
    function find(o) {
      return vs.find(function (v) { return o.every(function (x, i) { return x === null || v.options[i] === x; }); });
    }
    function mediaId(o) {
      var v = find(o);
      if (v && v.featured_media) return v.featured_media.id;
      if (colorIdx < 0 || !o[colorIdx]) return null;
      var alt = vs.find(function (x) { return x.options[colorIdx] === o[colorIdx] && x.featured_media; });
      return alt ? alt.featured_media.id : null;
    }
    function cur() {
      var c = root.querySelector('[data-pw-current]');
      return c ? parseInt(c.textContent, 10) - 1 : -1;
    }
    function show() {
      var id = mediaId(opts());
      if (!id) return;
      var s = root.querySelector('[data-pw-slide][data-media-id="' + id + '"]');
      if (!s) return;
      var n = parseInt(s.dataset.pwSlide, 10);
      var w = root.querySelector('[data-pw-slides]');
      if (w && Math.abs(w.scrollLeft - s.offsetLeft) > 2) w.scrollTo({ left: s.offsetLeft, behavior: 'auto' });
      if (n !== cur()) {
        var t = root.querySelector('[data-pw-thumb="' + n + '"]');
        if (t) t.click();
      }
    }
    var min = Infinity, minAll = Infinity, prices = {};
    vs.forEach(function (v) {
      prices[v.price] = 1;
      if (v.price < minAll) minAll = v.price;
      if (v.available !== false && v.price < min) min = v.price;
    });
    if (!isFinite(min)) min = minAll;
    var multi = Object.keys(prices).length > 1;
    var hasParam = false;
    try { hasParam = !!new URL(window.location.href).searchParams.get('variant'); } catch (e) {}
    var chosen = hasParam;
    var line = null;
    if (multi) {
      var groups = root.querySelectorAll('.pw-opt[data-pw-option-index]');
      var last = groups[groups.length - 1];
      if (last) {
        line = document.createElement('p');
        line.className = 'pw-opt-live';
        line.setAttribute('aria-live', 'polite');
        line.style.cssText = 'margin:12px 0 0;font-weight:700;font-size:18px;line-height:1.3;color:#111B38';
        last.appendChild(line);
      }
    }
    function label() {
      if (!multi) return;
      var v = find(opts());
      if (!v) return;
      var pr = root.querySelector('[data-pw-price]');
      var top = chosen ? money(v.price) : 'From ' + money(min);
      if (pr && pr.textContent.trim() !== top) pr.textContent = top;
      if (line) line.textContent = v.title + ' · ' + money(v.price);
      var txt = root.querySelector('[data-pw-atc] [data-pw-atc-text]');
      if (txt && v.available) {
        var t = 'Add to cart · ' + money(v.price);
        if (txt.textContent !== t) txt.textContent = t;
      }
    }
    root.addEventListener('click', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[data-pw-option-value]')) { chosen = true; setTimeout(function () { show(); label(); }, 0); }
    });
    root.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.pw-opt select, input[data-pw-option-value]')) { chosen = true; setTimeout(show, 0); }
      setTimeout(label, 30);
    });
    if (multi && window.MutationObserver) {
      var pr0 = root.querySelector('[data-pw-price]');
      if (pr0) new MutationObserver(function () { setTimeout(label, 0); }).observe(pr0, { childList: true, characterData: true, subtree: true });
      var at = root.querySelector('[data-pw-atc-text]');
      if (at) new MutationObserver(function () { if (/^Add to cart$/.test(at.textContent.trim())) label(); }).observe(at, { childList: true, characterData: true, subtree: true });
    }
    label();
    if (!hasParam) requestAnimationFrame(show);
  }
  function boot() {
    document.querySelectorAll('[data-pw-product]').forEach(bind);
    if (document.querySelector('[data-pw-pet-how]') && !document.getElementById('pw-959-css')) {
      var st = document.createElement('style'); st.id = 'pw-959-css';
      st.textContent = '#MainContent .pw-pet-how{display:none!important}';
      document.head.appendChild(st);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 50); });
})();
